import { v4 as uuid } from "uuid";

import getLocalStorage from "js/core/utilities/localStorage";

const localStorage = getLocalStorage();

// Id of the current session (gets reset on page refresh and bundle reload)
// used as trace id
const sessionId = uuid();

// Browser id, persisted in local storage
let browserId = localStorage.getItem("bai-browser-id");
if (!browserId) {
    browserId = uuid();
    localStorage.setItem("bai-browser-id", browserId);
}

export { sessionId, browserId };
